export default "__VITE_ASSET__CiNYpPb1__"